export default "__VITE_ASSET__Bq6Cqiod__"